import zh from "../messagesJson/zh.json";
export const PartialMessages = {
    zh,
} as const;
